export const OPEN_NEW_TASK_FORM = "@CREATE_TASK/OPEN_NEW_TASK_FORM";
export const OPEN_EDIT_TASK_FORM = "@CREATE_TASK/OPEN_EDIT_TASK_FORM";
export const PUT = '@CREATE_TASK/PUT';
export const CLOSE_TASK_FORM = "@CREATE_TASK/CLOSE_TASK_FORM";

export const actionCreators = {
    openNewTaskForm: () => ({ type: OPEN_NEW_TASK_FORM}),
    openEditTaskForm: (props) =>({ type: OPEN_EDIT_TASK_FORM, payload: props}),
    closeTaskForm: () =>({ type: CLOSE_TASK_FORM }) ,
    putTask: (task) => ({ type: PUT, payload: task }),
};
